import FadeIn from '../ui/FadeIn';
import { FileSpreadsheet, FileText, User } from 'lucide-react';

export default function FormatSelectorPreview() {
    return (
        <FadeIn delay={0.2}>
            <div className="max-w-sm mx-auto my-12">
                {/* Preview Card - exact replica of extension UI */}
                <div className="bg-[var(--color-md-surface-container)] rounded-[28px] p-6 shadow-cinematic-2 border border-[var(--color-md-outline)]/10">
                    <h3 className="text-[var(--color-md-on-surface-variant)] font-bold text-xs uppercase tracking-widest mb-5 opacity-70">
                        Export Format
                    </h3>

                    <div className="space-y-3">
                        {/* Excel Option - Selected */}
                        <div className="flex items-center gap-4 p-4 rounded-2xl bg-[var(--md-sys-color-primary-container)] border-2 border-[var(--md-sys-color-primary)] shadow-sm">
                            <div className="w-11 h-11 m3-icon-tonal flex-shrink-0">
                                <FileSpreadsheet className="w-5 h-5" />
                            </div>
                            <div className="flex-1">
                                <div className="font-bold text-[var(--md-sys-color-on-primary-container)] text-sm">Excel (.xlsx)</div>
                                <div className="text-xs text-[var(--md-sys-color-on-primary-container)] opacity-80 font-medium">Best for analysis</div>
                            </div>
                            <div className="w-6 h-6 rounded-full border-2 border-[var(--md-sys-color-primary)] bg-[var(--md-sys-color-primary)] flex items-center justify-center">
                                <div className="w-2.5 h-2.5 rounded-full bg-[var(--md-sys-color-on-primary)] shadow-sm"></div>
                            </div>
                        </div>

                        {/* CSV Option */}
                        <div className="flex items-center gap-4 p-4 rounded-2xl bg-[var(--color-md-surface-container-low)] border border-[var(--color-md-outline-variant)]/30 hover:border-[var(--color-md-outline-variant)] transition-colors group cursor-default">
                            <div className="w-11 h-11 m3-icon-secondary flex-shrink-0">
                                <FileText className="w-5 h-5" />
                            </div>
                            <div className="flex-1">
                                <div className="font-bold text-[var(--color-md-on-surface)] text-sm transition-colors">CSV</div>
                                <div className="text-xs text-[var(--color-md-on-surface-variant)] font-medium">Universal format</div>
                            </div>
                            <div className="w-6 h-6 rounded-full border-2 border-[var(--color-md-outline-variant)] transition-colors"></div>
                        </div>

                        {/* VCard Option */}
                        <div className="flex items-center gap-4 p-4 rounded-2xl bg-[var(--color-md-surface-container-low)] border border-[var(--color-md-outline-variant)]/30 hover:border-[var(--color-md-outline-variant)] transition-colors group cursor-default">
                            <div className="w-11 h-11 m3-icon-tertiary flex-shrink-0">
                                <User className="w-5 h-5" />
                            </div>
                            <div className="flex-1">
                                <div className="font-bold text-[var(--color-md-on-surface)] text-sm transition-colors">VCF (vCard)</div>
                                <div className="text-xs text-[var(--color-md-on-surface-variant)] font-medium">Mobile-ready</div>
                            </div>
                            <div className="w-6 h-6 rounded-full border-2 border-[var(--color-md-outline-variant)] transition-colors"></div>
                        </div>
                    </div>
                </div>

                {/* Caption */}
                <p className="text-center text-[10px] font-bold uppercase tracking-widest text-[var(--color-md-on-surface-variant)] mt-5 opacity-60">
                    ↑ Actual format selector in WaVault
                </p>
            </div>
        </FadeIn>
    );
}
